export default __webpack_public_path__ + "static/media/googleplay.c906cfce.png";